<template>
    <div class="aside" ref="aside" :class="{ 'aside-opened': isMenuOpened }">
        <p class="aside-mobile-main-item" :class="{ 'aside-mobile-main-item-active' : isMenuOpened }" @click="toggleMenu()">Select page</p>
        <ul class="aside-ul">
          <li v-for="(link, index) in linksArray" :key="index" class="aside-li" :class="{ 'aside-li-active': isMenuOpened }">
              <router-link class="aside-item" active-class="aside-item-active" :to="link.url" @click.native="itemSelected()">
                  {{link.name}}
              </router-link>
          </li>
        </ul>
    </div>
</template>

<script>
export default {
  props: ["linksArray"],
  data() {
    return {
      isMenuOpened: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpened = this.isMenuOpened === false ? true : false;
    },
    itemSelected() {
      setTimeout(() => {
        if (window.innerWidth < 1000) {
          // for mobile
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        } else {
          // for desktop
          window.scrollTo({
            top: this.$refs.aside.offsetTop - 100,
            behavior: "smooth"
          });
        }
      }, 10);
      this.isMenuOpened = false;
    }
  }
};
</script>

<style scoped>
.aside {
  width: 20%;
  padding-top: 15px;
  padding-bottom: 30px;
}
.aside-ul {
  padding: 10px 0 20px 0;
  border-right: 1px solid #c5d7e4;
}
.aside-li {
  display: block;
  text-align: right;
}
.aside-title {
  color: #00305b;
  display: block;
  font-size: 16px;
  padding: 15px 42px 15px 0;
  text-align: right;
}
.aside-item {
  border-right: 6px solid transparent;
  display: block;
  font-size: 16px;
  text-transform: uppercase;
  height: 100%;
  padding: 11px 36px 11px 0;
}
.aside-item:hover {
  border-right: 6px solid #00305b;
  color: #00305b;
}
.aside-item-active {
  border-right: 6px solid #00305b;
  color: #00305b;
  font-weight: 700;
}
.aside-mobile-main-item {
  display: none;
}
@media screen and (max-width: 1280px) {
  .aside {
    width: 30%;
  }
}
@media screen and (max-width: 1000px) {
  .aside {
    background-color: rgba(0, 71, 133, 0.98);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: 2px solid #fff;
    border-bottom: none;
    bottom: 0;
    left: 48px;
    max-height: calc(100vh - 90px);
    min-height: 50px;
    padding: 0;
    position: fixed;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    width: calc(100% - 96px);
    z-index: 9;
  }
  .aside::after {
    color: #fff;
    content: "M";
    font-size: 18px;
    font-family: "alcomet";
    height: 20px;
    position: absolute;
    right: 20px;
    top: 15px;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    width: 20px;
  }
  .aside-opened {
    z-index: 9;
  }
  .aside-opened::after {
    transform: rotate(-180deg);
  }
  .aside-mobile-main-item {
    align-items: center;
    color: #fff;
    font-size: 18px;
    display: flex;
    height: 50px;
    padding: 0 20px;
    position: relative;
    width: 100%;
    z-index: 1;
  }
  .aside-mobile-main-item-active {
    display: none;
  }
  .aside-ul {
    border: none;
    max-height: calc(100vh - 140px);
    overflow: auto;
    padding: 0;
  }
  .aside-li {
    height: 0px;
    opacity: 0;
    overflow: hidden;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    text-align: left;
    position: relative;
    z-index: 1;
  }
  .aside-li-active {
    height: 50px;
    opacity: 1;
  }
  .aside-item {
    align-items: center;
    border: none;
    color: #fff;
    display: flex;
    font-size: 18px;
    padding: 0 20px;
    text-transform: initial;
  }
  .aside-item:hover {
    border: none;
    color: #fff;
  }
  .pf-row-text {
    z-index: 0;
  }
}
@media screen and (max-width: 600px) {
  .aside-mobile-main-item,
  .aside-item {
    font-size: 16px;
  }
  .aside-li:first-of-type .aside-item {
    padding-right: 50px;
  }
}
@media screen and (max-width: 440px) {
  .aside {
    left: 30px;
    width: calc(100% - 60px);
  }
  .mobile-main-item,
  .aside-item {
    font-size: 13px;
  }
}
@media screen and (max-width: 380px) {
  .aside-mobile-main-item,
  .aside-item {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Aside.vue